// extracted by mini-css-extract-plugin
export default {"categoryTag":"styles_categoryTag__p+wx6"};